var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie-player',{ref:"player",staticClass:"lottie-player",style:({ aspectRatio: _vm.blok.aspectRatio || '16/9' }),attrs:{"speed":"1","autoplay":"","loop":""}})}
var staticRenderFns = []

export { render, staticRenderFns }